<template>
  <div id="app">
    <Navbar class="mb-3"></Navbar>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
  import Navbar from "./components/Navbar";
  import Footer from "./components/Footer";

  export default {
    name: 'App',
    components: {Footer, Navbar},
    watch: {
      '$route'(to, from) {
        document.title = 'OSRS Genie - ' + to.meta.title || 'OSRS Genie'
      }
    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue